import * as mutationTypes from "../mutation-types";

// initial state
const state = {
	persistedData: {
		highlightedGroupsWithMissingSelection: []
	}
};

// getters
const getters = {
	highlightedGroupsWithMissingSelection: state => state.persistedData.highlightedGroupsWithMissingSelection
};

// actions
const actions = {

};

// mutations
const mutations = {
	[mutationTypes.HIGHLIGHT_GROUPS_WITH_MISSING_SELECTION] (state, groups) {
		state.persistedData.highlightedGroupsWithMissingSelection = groups;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
